import * as React from "react";

import { cn } from "@/lib/utils";
import { Label } from "./label";

type TextAreaProps = React.ComponentProps<"textarea"> & { label?: string };
function TextArea({ className, label, ...props }: TextAreaProps) {
  return (
    <div>
      {!!label && (
        <div className="my-3 capitalize">
          <Label>{label}</Label>
        </div>
      )}
      <textarea
        rows={4}
        className={cn(
        "border-gray-500 file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex w-full min-w-0 rounded-md border bg-transparent px-3 py-2 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-md file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm text-body",
          // "focus-visible:border-primary focus-visible:ring-ring/30 focus-visible:ring-[1px]",
          // "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className
        )}
        {...props}
      />
    </div>
  );
}

export default TextArea;
